import { render, staticRenderFns } from "./invoice-pdf-page2.vue?vue&type=template&id=b888ef50&"
import script from "./invoice-pdf-page2.vue?vue&type=script&lang=ts&"
export * from "./invoice-pdf-page2.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-pdf-page2.vue?vue&type=style&index=0&id=b888ef50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports